import React, { useEffect } from 'react';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Logout from '@mui/icons-material/Logout';
import { useAuthSlice } from 'reducers/auth';
import { useDispatch, useSelector } from 'react-redux';
import { selectUserName } from 'reducers/user/selector';
import { Typography } from '@mui/material';
import { useUserSlice } from 'reducers/user';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
	focusVisible: {
		'&:focus': {
			profileIcon: {
				backgroundColor: '#ffffff',
				color: '#3374C1',
			},
		},
	},
	profileIcon: {
		backgroundColor: '#ffffff',
		color: '#3374C1',
		'&:focus': {
			'& span': {
				backgroundColor: '#ffffff',
				color: 'white',
			},
		},
	},
}));

export default function AccountMenu() {
	const classes = useStyles();
	const { logoutAction } = useAuthSlice();
	const { fetchCurrentUserDetail } = useUserSlice();
	const dispatch = useDispatch();

	const username = useSelector(selectUserName);

	const [anchorEl, setAnchorEl] = React.useState(null);
	const open = Boolean(anchorEl);

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleLogout = () => {
		dispatch(logoutAction());
	};

	useEffect(() => {
		if (!username) {
			dispatch(fetchCurrentUserDetail());
		}
	}, [username]);

	return (
		<React.Fragment>
			<Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
				<Tooltip title="Account settings">
					<IconButton
						onClick={handleClick}
						size="small"
						sx={{ ml: 2 }}
						aria-controls={open ? 'account-menu' : undefined}
						aria-haspopup="true"
						aria-expanded={open ? 'true' : undefined}
						className={classes.focusVisible}
					>
						<Avatar
							sx={{ width: 32, height: 32 }}
							className={classes.profileIcon}
						>
							{username?.charAt(0)?.toUpperCase()}
						</Avatar>
					</IconButton>
				</Tooltip>
			</Box>
			<Menu
				anchorEl={anchorEl}
				id="account-menu"
				open={open}
				onClose={handleClose}
				onClick={handleClose}
				PaperProps={{
					elevation: 0,
					sx: {
						overflow: 'visible',
						filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
						mt: 1.5,
						'& .MuiAvatar-root': {
							width: 32,
							height: 32,
							ml: -0.5,
							mr: 1,
						},
						'&:before': {
							content: '""',
							display: 'block',
							position: 'absolute',
							top: 0,
							right: 14,
							width: 10,
							height: 10,
							bgcolor: 'background.paper',
							transform: 'translateY(-50%) rotate(45deg)',
							zIndex: 0,
						},
					},
				}}
				transformOrigin={{ horizontal: 'right', vertical: 'top' }}
				anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
			>
				<MenuItem>
					<Avatar /> <Typography>Welcome {username}</Typography>
				</MenuItem>
				<Divider aria-hidden />
				<MenuItem onClick={handleLogout}>
					<ListItemIcon>
						<Logout fontSize="small" />
					</ListItemIcon>
					Log out
				</MenuItem>
			</Menu>
		</React.Fragment>
	);
}
